export default __webpack_public_path__ + "static/media/profile-form-date.e3c5e929.svg";